/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IUserInfoModel } from "../../models";
import * as Consts from "./consts";
import { AuthActionsTypes, IAuthState } from "./types";

export const initialState: IAuthState = {
  isLoading: false,
  isCodeVerified: false,
  isInitialized: false,
  isCompleted: false,
  isChild: false,
  changePasswordStatus: "idle",
  syncStatus: "idle",
};

export const authReducer = (
  state = initialState,
  action: AuthActionsTypes
): IAuthState => {
  switch (action.type) {
    case Consts.SIGN_IN:
    case Consts.SIGN_IN_VIA_TOKEN:
    case Consts.GET_SESSION_DETAILS: {
      return {
        ...state,
        error: undefined,
        isLoading: true,
        isInitialized: true,
      };
    }
    case Consts.VALIDATE_ACTIVATION_CODE: {
      return {
        ...state,
        error: undefined,
        isLoading: true,
        isCodeVerified: false,
        isCompleted: false,
      };
    }
    case Consts.SIGN_IN_SUCCESS:
    case Consts.SIGN_IN_WEB_SUCCESS:
    case Consts.SIGN_IN_VIA_TOKEN_SUCCESS: {
      return {
        ...state,
        user: action.payload.user,
        session: action.payload.session,
        error: undefined,
        isInitialized: true,
        isLoading: false,
        isCompleted: true,
      };
    }
    case Consts.VALIDATE_ACTIVATION_CODE_SUCCESS: {
      return {
        ...state,
        error: undefined,
        isCodeVerified: true,
        isLoading: false,
        isCompleted: true,
      };
    }
    case Consts.SET_IS_CHILD: {
      return {
        ...state,
        isChild: action.payload,
      };
    }
    case Consts.SIGN_IN_FAILURE:
    case Consts.SIGN_IN_VIA_TOKEN_FAILURE:
    case Consts.GET_SESSION_DETAILS_FAILURE: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isCompleted: true,
      };
    }
    case Consts.VALIDATE_ACTIVATION_CODE_FAILURE: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isCodeVerified: false,
        isCompleted: true,
      };
    }
    case Consts.SIGN_OUT_SUCCESS:
    case Consts.REFRESH_TOKEN_FAILURE: {
      return {
        ...state,
        session: undefined,
        user: undefined,
      };
    }
    case Consts.GET_SESSION_DETAILS_SUCCESS: {
      return {
        ...state,
        session: {
          ...state.session,
          IsOverTheDeviceLimit: action.payload.session.overTheDeviceLimit,
        },
        error: undefined,
        isLoading: false,
      };
    }
    case Consts.REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        session: { ...state.session, ...action.payload.session },
      };
    }
    case Consts.CLEAR_CHANGE_PASSWORD_RESULT: {
      return {
        ...state,
        changePasswordStatus: "idle",
      };
    }
    case Consts.CHANGE_PASSWORD: {
      return {
        ...state,
        isCompleted: false,
        isLoading: true,
        changePasswordStatus: "idle",
      };
    }
    case Consts.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        session: action.payload,
        isCompleted: true,
        isLoading: false,
        changePasswordStatus: "success",
      };
    }
    case Consts.CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        error: action.error,
        isCompleted: true,
        isLoading: false,
        changePasswordStatus: "error",
      };
    }
    case Consts.SYNC_USER: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case Consts.SYNC_WEB_USER: {
      return {
        ...state,
        isLoading: true,
        isInitialized: true,
        isCompleted: false,
        syncStatus: "loading",
      };
    }
    case Consts.SYNC_WEB_USER_SUCCESS: {
      return {
        ...state,
        user: { ...state.user, ...action.payload.customer },
        session: action.payload.session,
        isChild: action.payload.currentSubProfile.Child,
        isLoading: false,
        isInitialized: true,
        isCompleted: true,
        syncStatus: "success",
      };
    }
    case Consts.SYNC_USER_SUCCESS: {
      return {
        ...state,
        session: action.payload.session,
        isLoading: false,
        isInitialized: true,
        isCompleted: true,
      };
    }
    case Consts.SYNC_USER_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isInitialized: true,
        isCompleted: true,
        error: undefined,
        syncStatus: "error",
      };
    }
    case Consts.REFRESH_USER: {
      const user: IUserInfoModel = {
        Id: -1,
        ...state.user,
        FullName: action.payload.FullName,
        AvatarUrl: action.payload.AvatarUrl,
        PhoneNumber: action.payload.PhoneNumber,
        Email: action.payload.Email ?? state.user?.Email,
      };
      return {
        ...state,
        user,
      };
    }
    case Consts.UPDATE_TOKENS: {
      return {
        ...state,
        session: action.payload,
      };
    }
    default:
      return state;
  }
};
